import {
  useEffect,
  useState
} from "react";

import {
  useParams,
  useNavigate
} from "react-router-dom";

import api from "../../api";

function ReservationDetails() {

  const { id } =
    useParams();

  const navigate =
    useNavigate();

  const [reservation, setReservation] =
    useState(null);

  const [loading, setLoading] =
    useState(true);

  // =====================
  // FETCH
  // =====================

  const loadReservation =
    async () => {

      try {

        setLoading(true);

        const res =
          await api.get(
            `/reservations/${id}`
          );

        setReservation(
          res.data
        );

      } catch (err) {

        console.error(err);

        alert(
          "Erreur chargement réservation"
        );

      }

      setLoading(false);
    };

  useEffect(() => {

    loadReservation();

  }, [id]);

  // =====================
  // TERMINER
  // =====================

  const terminerOccupation =
    async () => {

      if (
        !window.confirm(
          "Confirmer la fin ?"
        )
      ) {
        return;
      }

      try {

        await api.post(
          `/reservations/${id}/terminer`
        );

        alert(
          "Occupation terminée"
        );

        loadReservation();

      } catch (err) {

        alert(
          err?.response
            ?.data?.message ||
            "Erreur serveur"
        );

      }
    };

  // =====================
  // LOADING
  // =====================

  if (loading) {

    return (
      <p className="p-4 md:p-6 text-center">
        Chargement...
      </p>
    );

  }

  // =====================
  // RENDER
  // =====================

  return (
    <div className="min-h-[100dvh] bg-gray-100 p-3 md:p-6">

      <div className="max-w-2xl mx-auto space-y-5">

        {/* HEADER */}
        <div className="flex flex-col md:flex-row justify-between md:items-center gap-3">

          <h2 className="text-2xl md:text-3xl font-bold">
            Détail réservation
          </h2>

          <button
            onClick={() =>
              navigate(-1)
            }
            className="bg-gray-200 hover:bg-gray-300 transition px-4 py-3 rounded-xl"
          >
            ⬅️ Retour
          </button>

        </div>

        {/* CARD */}
        <div className="bg-white shadow rounded-2xl p-4 md:p-6 space-y-5">

          {/* CLIENT */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

            <div>

              <p className="text-sm text-gray-500">
                Client
              </p>

              <p className="font-semibold break-words">
                {
                  reservation.client_nom
                }
              </p>

            </div>

            <div>

              <p className="text-sm text-gray-500">
                Téléphone
              </p>

              <p className="font-semibold">
                {
                  reservation.telephone
                }
              </p>

            </div>

            <div>

              <p className="text-sm text-gray-500">
                Chambre
              </p>

              <p className="font-semibold">
                {
                  reservation.chambre_id
                }
              </p>

            </div>

            <div>

              <p className="text-sm text-gray-500">
                Prix
              </p>

              <p className="font-semibold text-green-600">
                {
                  reservation.prix_facture
                }
                $
              </p>

            </div>

          </div>

          {/* STATUT */}
          <div className="border rounded-2xl p-4 bg-gray-50">

            <p className="text-sm text-gray-500">
              Statut
</p>

<div className="mt-2">

  {reservation.statut ===
  "active" ? (

    <span className="bg-green-100 text-green-700 px-4 py-2 rounded-xl text-sm font-semibold">
      Occupée
    </span>

  ) : (

    <span className="bg-gray-200 text-gray-700 px-4 py-2 rounded-xl text-sm font-semibold">
      Terminée
    </span>

  )}

</div>

</div>

{/* DATES */}
<div className="grid grid-cols-1 md:grid-cols-2 gap-4">

  <div>

    <p className="text-sm text-gray-500">
      Début
    </p>

    <p className="font-semibold">
      {reservation.date_debut
        ? new Date(
            reservation.date_debut
          ).toLocaleDateString()
        : "-"}
    </p>

  </div>

  <div>

    <p className="text-sm text-gray-500">
      Fin prévue
    </p>

    <p className="font-semibold">
      {reservation.date_fin
        ? new Date(
            reservation.date_fin
          ).toLocaleDateString()
        : "-"}
    </p>

  </div>

</div>

{/* ACTIONS */}
<div className="grid grid-cols-1 md:grid-cols-2 gap-3 pt-2">

  <button
    onClick={() =>
      navigate(
        `/facture/${reservation.id}`
      )
    }
    className="bg-indigo-600 hover:bg-indigo-700 transition text-white py-3 rounded-xl"
  >
    Voir facture
  </button>

  {reservation.statut ===
    "active" && (

    <button
      onClick={
        terminerOccupation
      }
      className="bg-red-600 hover:bg-red-700 transition text-white py-3 rounded-xl"
    >
      Terminer occupation
    </button>

  )}

</div>

</div>

</div>

</div>
  );
}

export default ReservationDetails;